/**
 * Computes column count and width for a given container width and constraints.
 *
 * Masonic's `usePositioner` computes columns internally via `getColumns`, but
 * that function is tightly coupled to the positioner's option-change detection:
 * any change to `width` (even a single pixel from a scrollbar appearing)
 * triggers a full item re-layout. By computing `columnCount` externally and
 * passing it to `usePositioner` with `deps: [columnCount]`, the positioner
 * only resets when the number of columns actually changes — not on every
 * minor width fluctuation.
 */
function computeColumns(
  containerWidth: number,
  minColumnWidth: number,
  maxColumnWidth: number,
  columnGutter: number
): {columnCount: number; columnWidth: number} {
  if (containerWidth <= 0) {
    return {columnCount: 1, columnWidth: minColumnWidth};
  }
  const columnCount = Math.max(
    1,
    Math.floor(
      (containerWidth + columnGutter) / (minColumnWidth + columnGutter)
    )
  );
  const columnWidth = Math.min(
    maxColumnWidth,
    (containerWidth - (columnCount - 1) * columnGutter) / columnCount
  );
  return {columnCount, columnWidth};
}

export default computeColumns;
